import { fetchCatalogNames } from 'modules/catalogTable/actions';
import { fetchCatalogFieldTypesRequest } from 'modules/catalogFieldTypes/actions';

/**
 * Common Catalog Actions
 */
export const fetchCatalogFieldTypes = fetchCatalogFieldTypesRequest;

export { fetchCatalogNames };
